
/* injects from baggage-loader */


export const getSwarmSubscriptionRequestCashdesk = () => {
    let request = {
        "source": "cashdesk",
        "what": {
            "cashdesk": []
        },
        "subscribe": "true"
    };

    return request;
};